import { FC, useEffect, useState, useRef } from 'react';
import AliyunUploadFile from './aliyunUploadFile';
import MinioUploadFile from './minioUploadFile';
import { oss_file_getPostPolicy_api } from '../../api/oss/file';
import {
  OSSDataConfig,
  AliyunUploadFileProps,
  MinioUploadFileProps,
  EXPIRE_TIME,
  EXPIRE_EFFECTIVE_TIME,
} from '../interface';
import { SUCCESS_STATUS_CODE } from '../../constants/constant';

export type UploadFileProps = AliyunUploadFileProps | MinioUploadFileProps;

const UploadFile: FC<UploadFileProps> = props => {
  const { scene } = props;
  const [OSSData, setOSSData] = useState<OSSDataConfig>();
  const timer = useRef<any>();
  useEffect(() => {
    init();
  }, []);
  /** 初始化数据 */
  const init = async () => {
    if (!scene) return;
    const CACHE_SCENE = window.sessionStorage.getItem(scene);
    if (!CACHE_SCENE) {
      window.sessionStorage.setItem(scene, 'loading');
      const res = await oss_file_getPostPolicy_api(scene);
      if (res.code === SUCCESS_STATUS_CODE) {
        const data = res.data;
        const {
          /** 上传地址 */
          host,
          /** 上传成功后文件的访问路径前缀 */
          endpoint,
          policy,
          accessid,
          signature,
          /** 文件夹目录 */
          dir,
          /** 有效时间 */
          effectiveDuration = EXPIRE_EFFECTIVE_TIME,
          /** 类型 */
          type,
          /** 可上传的文件类型 */
          allowList,
          /** 过期时间 */
          expire,
        } = data;
        const effectiveTime = Date.now() + effectiveDuration;
        const newOSSData = {
          host,
          endpoint,
          policy,
          accessid,
          signature,
          dir,
          effectiveTime,
          expire: expire || effectiveTime,
          type,
          accept: Array.isArray(allowList)
            ? allowList.map(v => `.${v}`).join(',')
            : undefined,
        };
        window.sessionStorage.setItem(scene, JSON.stringify(newOSSData));
        setOSSData(newOSSData);
      }
    }
    if (CACHE_SCENE === 'loading') {
      timer.current = setInterval(() => {
        const resData = window.sessionStorage.getItem(scene);
        if (resData && resData !== 'loading') {
          clearInterval(timer.current);
          setOSSData(JSON.parse(resData));
        }
        if (!resData) clearInterval(timer.current);
      }, 50);
      return;
    }
    if (CACHE_SCENE) {
      const oldOSSData = JSON.parse(CACHE_SCENE);
      const { expire } = oldOSSData;
      const expireTime = Number(expire) * 1000;
      const nowTime = Date.now() + EXPIRE_TIME;
      if (expireTime < nowTime) {
        window.sessionStorage.setItem(scene, '');
        init();
        return;
      }
      setOSSData(oldOSSData);
    }
  };
  return (
    <>
      {OSSData?.type === 'aliyun' && (
        <AliyunUploadFile
          OSSData={OSSData}
          onReset={init}
          accept={OSSData.accept}
          scene={scene}
          {...props}
        />
      )}
      {OSSData?.type === 'minio' && (
        <MinioUploadFile
          uploadUrl={OSSData.host}
          onReset={init}
          accept={OSSData.accept}
          {...props}
        />
      )}
    </>
  );
};

export default UploadFile;
